import React from "react";
import { Container, Card, CardBody, Row, Col, Media, Label, FormGroup } from "reactstrap";
import { Link } from "react-router-dom";
import Breadcrumb from "../../components/Common/Breadcrumb";
import img1 from "../../assets/images/companies/iicc-logo-new.png";
import img2 from "../../assets/images/companies/sobha.png";
import LKPhoneImg from "../../assets/images/LK_Icons/LK__Phone.svg";
import LKUserImg from "../../assets/images/LK_Icons/LK__User.svg";
import LKChargerImg from "../../assets/images/LK__EV charger_blue.svg";
import { connect } from "react-redux";
import { loadHost } from "../../api/utils/loadHost";
import { useState } from "react";
import { useEffect } from "react";
import { MDBDataTable } from "mdbreact";
import Spinner from "../Utility/Spinner";
import LKRadioBtnCheck from "../../assets/images/LK_Icons/LK__Radio Button Check.svg";
import LKRadioBtnUnCheck from "../../assets/images/LK_Icons/LK__Radio Button Uncheck.svg";
import Cookies from "js-cookie";
import { hostSelected } from "../../store/hostTech/actions";
import { getHostById } from "../../api/authAPI";
const KeyAccounts = (props) => {
  const { hostSelected } = props;
  const breadcrumbItems = [
    { title: "Charger Management System", link: "#" },
    { title: "Key Accounts", link: "#" },
  ];
  const [isLoading, setIsLoading] = useState(false);
  const [hostDetails, setHostDetails] = useState([]);

  // on component mount load the host details
  useEffect(() => {
    handleLoadHost();
  }, []);

  const handleLoadHost = async () => {
    try {
      const data = await getHostById(props?.user?.parentId);
      const { name, phoneNumber, email, type, gst, address } = data;
      console.log("data: ", data);
      const projectDetails = [
        {
          name,
          phoneNumber,
          email,
          noOfCharger: props.chargerIds?.length,
        },
      ];
      setIsLoading(true);
      // const data = await loadHost(props?.hostIds);

      const hostData = projectDetails?.map((item, index) => {
        const { name, email, phoneNumber, role, type, noOfCharger, noOfTrans } = item;
        return {
          slno: index + 1,
          name: name,
          email: email,
          phoneNumber: phoneNumber,
          // role: role,
          // type: type,
          noOfCharger: noOfCharger,
          // noOfTrans: noOfTrans,
        };
      });
      setHostDetails(hostData);
    } catch (e) {
      console.log("Error Images Data: ", e);
    } finally {
      setIsLoading(false);
    }
  };

  const tableData = {
    columns: [
      { label: "Sl No.", field: "slno", sort: "asc", width: 20 },
      { label: "Name", field: "name", sort: "asc", width: 20 },
      { label: "Email", field: "email", sort: "asc", width: 20 },
      { label: "Phone Number", field: "phoneNumber", sort: "asc", width: 20 },
      // { label: "Role", field: "role", sort: "asc", width: 20 },
      // { label: "Type", field: "type", sort: "asc", width: 20 },
      { label: "No of Projects", field: "noOfCharger", sort: "asc", width: 20 },
      // { label: "No of Session", field: "noOfTrans", sort: "asc", width: 20 },
    ],
    rows: hostDetails,
  };
  const handleHostClick = (email) => {
    hostSelected(email);
    props.history.push("/cms-add-host");
    // props?.history?.push("/cms-add-host")
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Key Accounts" breadcrumbItems={breadcrumbItems} />
          {/* <Card>
            View Layout
          </Card> */}
          {/* select layout */}

          <Row>
            {isLoading ? (
              <Col className=" d-flex align-items-center justify-content-center" style={styles.loaderContainer}>
                <Spinner />
              </Col>
            ) : (
              <Col lg={12}>
                <Card className="p-3">
                  <MDBDataTable hover responsive data={tableData} />
                </Card>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const styles = {
  colonStyle: { width: "10px", textAlign: "center" },
  valueStyle: { marginLeft: "5px" },
  imgStyle: { width: "16px", height: "16px", marginRight: "5px" },
  loaderContainer: { height: "290px" },
  viewAs: { display: "flex", gap: "15px", marginTop: "4px", marginBottom: "0px" },
};
const mapStateToProps = (state) => ({
  hostIds: state?.HostTechManagement?.hostIds,
  user: state?.Login?.user,
  chargerIds: state?.ChargerManagement?.chargerIds,
});
const mapDispatchToProps = (dispatch) => ({
  hostSelected: (payload) => dispatch(hostSelected(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(KeyAccounts);
